export class Conversion {
	private fiat: string = "";
	private crypto: string = "";
	private fiat_bfc: string = "";
	private crypto_bfc: string = "";
	private best_amount_required_bfc: string = "";
	private asset_bonus_bfc: string = "";
	private fiat_bonus_bfc: string = "";

	public fiatAmount(): string {
		return this.fiat;
	}

	public getAssetBonusBfc(): string {
		return this.asset_bonus_bfc;
	}

	public getFiatBonusBfc(): string {
		return this.fiat_bonus_bfc;
	}

	public tradableAmount(): string {
		return this.crypto;
	}

	public setTradableAmount(s: string): void {
		this.crypto = s;
	}

	public setFiatAmount(s: string): void {
		this.fiat = s;
	}

	public getFiat(): string {
		return this.fiat;
	}

	public get cryptoBfc(): string {
		return this.crypto_bfc;
	}

	public get fiatBfc(): string {
		return this.fiat_bfc;
	}

	public get requiredBestAmount(): string {
		return this.best_amount_required_bfc;
	}
}
